import React, { useEffect, useRef } from 'react';
import axios from 'axios';

// Renders Google Identity Services' "Sign in with Google" button and posts
// the resulting credential to /api/auth/google. Separate from the Workspace
// OAuth connect flow (google.js / GoogleIntegrationCard) - this only ever
// requests basic profile/email, for public login/signup.
const GoogleSignInButton = ({ apiUrl, onAuth, onError, acceptedTerms = true }) => {
  const buttonRef = useRef(null);
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  useEffect(() => {
    if (!clientId || !acceptedTerms) return undefined;
    let cancelled = false;
    let attempts = 0;

    const handleCredentialResponse = async (response) => {
      try {
        const res = await axios.post(`${apiUrl}/auth/google`, {
          credential: response.credential,
          accepted_terms: acceptedTerms
        });
        onAuth({ token: res.data.token, user: res.data.user });
      } catch (err) {
        onError?.(err.response?.data?.error || 'Google sign-in failed');
      }
    };

    const tryRender = () => {
      if (cancelled) return;
      if (window.google?.accounts?.id) {
        window.google.accounts.id.initialize({ client_id: clientId, callback: handleCredentialResponse });
        if (buttonRef.current) {
          buttonRef.current.innerHTML = '';
          window.google.accounts.id.renderButton(buttonRef.current, {
            theme: 'outline',
            size: 'large',
            width: 320,
            text: 'continue_with'
          });
        }
      } else if (attempts < 50) {
        attempts += 1;
        setTimeout(tryRender, 100);
      }
    };
    tryRender();

    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, acceptedTerms]);

  if (!clientId) return null;

  if (!acceptedTerms) {
    return (
      <p className="text-muted" style={{ fontSize: '0.8rem', textAlign: 'center', margin: '14px 0' }}>
        Check the box above to sign up with Google.
      </p>
    );
  }

  return <div ref={buttonRef} style={{ display: 'flex', justifyContent: 'center', margin: '14px 0' }} />;
};

export default GoogleSignInButton;
